import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React example components
import MDComplaintStatusDialog from "components/MDComplaintStatusDialog";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Images
import brandDark from "assets/images/somosure/logo.png";

import {
  complaintStatusUpdating,
  getComplaintSingle,
} from "actions/complaintActions";
import MDButton from "components/MDButton";

function ComplaintManagementDetails() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const singleComplaint = useSelector((state) => state.singleComplaint);
  const { complaintSingle } = singleComplaint;

  useEffect(() => {
    dispatch(getComplaintSingle(id));
  }, [dispatch, id]);

  const handleAgreeActivateDeactivate = (status) => {
    console.log(
      "complaint-details handleAgreeActivateDeactivate modal",
      status
    );
    dispatch(complaintStatusUpdating({ status: status }, id));
  };

  function renderRequirementsRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        response: (
          <MDBox maxWidth={150}>
            <MDTypography
              key={index}
              variant="caption"
              color="text"
              fontWeight="medium"
            >
              {item?.responseRequirement}
            </MDTypography>
          </MDBox>
        ),
        type: (
          <MDBox maxWidth={200}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.responseRequirementType}
            </MDTypography>
          </MDBox>
        ),
        date: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(item?.updated_at).format("DD/MM/YYYY")}
          </MDTypography>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar
        title={`${complaintSingle?.order?.requestedBy?.name}'s Complaint Details`}
      />
      <MDBox mt={6} mb={6}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={5} lineHeight={0}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      component="img"
                      src={brandDark}
                      alt="Brand"
                      width="9rem"
                    />
                  </MDBox>

                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      component="img"
                      src={complaintSingle?.order?.supplier?.supplierLogo}
                      alt="Brand"
                      width="5rem"
                    />
                  </MDBox>
                </MDBox>

                <MDBox display="flex" justifyContent="space-between" mb={10}>
                  <MDBox>
                    <MDTypography variant="h6">
                      Vertical Lakes Fisheries
                    </MDTypography>
                    <MDTypography variant="h6">Nairobi, Kenya</MDTypography>
                    <MDTypography variant="h6">
                      Email:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        verticallakes@mail.com
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Phone:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        +254 700 112344
                      </MDTypography>
                    </MDTypography>
                  </MDBox>

                  <MDBox textAlign="right">
                    <MDTypography variant="h6">
                      {complaintSingle?.order?.supplier?.supplierName}
                    </MDTypography>
                    <MDTypography variant="h6">
                      {complaintSingle?.order?.supplier?.supplierAddress}
                    </MDTypography>
                    <MDTypography variant="h6">
                      Email:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {complaintSingle?.order?.supplier?.supplierEmail}
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Phone:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {complaintSingle?.order?.supplier?.supplierPhone}
                      </MDTypography>
                    </MDTypography>
                  </MDBox>
                </MDBox>

                <MDBox display="flex" justifyContent="space-between" mb={5}>
                  <MDBox>
                    <MDTypography variant="h6">Complaint No.</MDTypography>
                    <MDTypography
                      variant="button"
                      color="text"
                      fontWeight="regular"
                    >
                      #{complaintSingle?.complaintNumber}
                    </MDTypography>

                    <MDBox>
                      <MDTypography variant="h6">
                        Complaint Description:
                      </MDTypography>
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        #{complaintSingle?.description}
                      </MDTypography>
                    </MDBox>
                  </MDBox>

                  <MDBox textAlign="right">
                    <MDTypography variant="h6">
                      Client:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {complaintSingle?.order?.requestedBy?.name}
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Email:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {complaintSingle?.order?.requestedBy?.email}
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Phone:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {complaintSingle?.order?.requestedBy?.phone}
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Joined vertical lakes:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {moment(
                          complaintSingle?.order?.requestedBy?.created_at
                        ).fromNow()}
                      </MDTypography>
                    </MDTypography>
                  </MDBox>
                </MDBox>

                <MDBox p={3} mb={5}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Client",
                          accessor: "client",
                          width: "25%",
                          align: "left",
                        },
                        {
                          Header: "Complaint Number",
                          accessor: "complaint",
                          width: "20%",
                          align: "left",
                        },
                        {
                          Header: "Product Number",
                          accessor: "product",
                          width: "20%",
                          align: "left",
                        },
                        {
                          Header: "Amount",
                          accessor: "amount",
                          width: "15%",
                          align: "center",
                        },
                        {
                          Header: "Complaint State",
                          accessor: "state",
                          width: "10%",
                          align: "center",
                        },
                        {
                          Header: "Date",
                          accessor: "date",
                          width: "10%",
                          align: "center",
                        },
                      ],

                      rows: [
                        {
                          client: (
                            <MDBox maxWidth={300}>
                              <MDTypography
                                variant="caption"
                                color="text"
                                fontWeight="medium"
                              >
                                {complaintSingle?.order?.requestedBy?.name}
                              </MDTypography>
                            </MDBox>
                          ),
                          complaint: (
                            <MDBox>
                              <MDTypography
                                variant="caption"
                                color="text"
                                fontWeight="medium"
                                mb={1}
                              >
                                {complaintSingle?.complaintNumber}
                              </MDTypography>
                            </MDBox>
                          ),
                          product: (
                            <MDBox>
                              <MDTypography
                                variant="caption"
                                color="text"
                                fontWeight="medium"
                                mb={1}
                              >
                                {complaintSingle?.order?.product?.productName} -{" "}
                                {complaintSingle?.order?.product?.productNumber}
                              </MDTypography>
                            </MDBox>
                          ),
                          amount: (
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              Ksh. {complaintSingle?.amount}
                            </MDTypography>
                          ),
                          state: (
                            <MDBox width="8rem" textAlign="center">
                              <MDBox ml={-1}>
                                <MDBadge
                                  badgeContent={complaintSingle?.status}
                                  color={
                                    complaintSingle?.status == "approved"
                                      ? "success"
                                      : complaintSingle?.status == "rejected"
                                      ? "error"
                                      : "info"
                                  }
                                  variant="gradient"
                                  size="sm"
                                />
                              </MDBox>
                            </MDBox>
                          ),
                          date: (
                            <>
                              <MDTypography
                                component="a"
                                href="#"
                                variant="caption"
                                color="text"
                                fontWeight="medium"
                              >
                                {moment(complaintSingle?.created_at).format(
                                  "DD/MM/YYYY"
                                )}
                              </MDTypography>
                            </>
                          ),
                        },
                      ],
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>

                <MDBox>
                  <MDTypography variant="h6">
                    Provided Complaint Requirements
                  </MDTypography>
                </MDBox>
                <MDBox p={3} mb={5}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Response Required",
                          accessor: "response",
                          width: "20%",
                          align: "left",
                        },
                        {
                          Header: "Response Type",
                          accessor: "type",
                          width: "30%",
                          align: "left",
                        },
                        {
                          Header: "Provided",
                          accessor: "date",
                          width: "10%",
                          align: "center",
                        },
                      ],

                      rows: renderRequirementsRows(
                        complaintSingle?.responseRequirements
                      ),
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>

                <MDBox display="flex" justifyContent="space-between" mb={5}>
                  <MDBox>
                    <MDTypography variant="h6">#</MDTypography>
                    <MDBox>
                      <MDComplaintStatusDialog
                        title={`${"Update "} ${
                          complaintSingle?.order?.requestedBy?.name
                        }'s Complaint State`}
                        currentStatus={complaintSingle?.status}
                        onAgree={(status) =>
                          handleAgreeActivateDeactivate(status)
                        }
                        customButton={
                          <MDBox mt="auto">
                            <MDButton
                              component="a"
                              href="#"
                              rel="noreferrer"
                              variant="gradient"
                              color="info"
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                              &nbsp;Update Complaint State
                            </MDButton>
                          </MDBox>
                        }
                      />
                    </MDBox>
                  </MDBox>

                  <MDBox textAlign="flex-end" mr={5}>
                    <MDBox
                      display="flex"
                      flexDirection="row"
                      py={1}
                      justifyContent="flex-end"
                    >
                      <MDTypography variant="body2" color="text">
                        Complaint Requested Amount:{" "}
                      </MDTypography>
                      <MDTypography variant="h5" pl={3}>
                        Ksh. {complaintSingle?.amount}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ComplaintManagementDetails;
